var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle_Grid",
    "data-name": "Circle Grid"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    fill: "#3b5059",
    r: 64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#69b0ee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.479 54.014 2.67-2.671-17.695-17.695-1.967 1.968a18.482 18.482 0 0 0 -5.42 11.417c-.5 5.934 1.831 13.013 5.507 20.129a79.343 79.343 0 0 0 33.926 33.945c7.124 3.688 14.21 6.023 20.15 5.507a18.363 18.363 0 0 0 11.415-5.414l1.968-1.968-17.7-17.7-2.665 2.668a7.445 7.445 0 0 1 -10.527 0l-19.662-19.66a7.442 7.442 0 0 1 0-10.526z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.6 100.651 1.436-1.436a3.594 3.594 0 0 0 0-5.083l-12.61-12.612a3.6 3.6 0 0 0 -5.084 0l-1.435 1.436z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.718 52.767 1.435-1.436a3.594 3.594 0 0 0 0-5.083l-12.611-12.612a3.6 3.6 0 0 0 -5.084 0l-1.435 1.436z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m103 36.554v18.4a7.235 7.235 0 0 1 -7.239 7.239h-17.517l-10.873 9.83v-9.83h-5.39a7.238 7.238 0 0 1 -7.239-7.239v-18.4a7.242 7.242 0 0 1 7.239-7.239h33.78a7.238 7.238 0 0 1 7.239 7.239z",
    fill: "#eeefee"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#bbbbcd",
    height: 2.163,
    rx: 1.081,
    width: 36.46,
    x: 60.641,
    y: 37.025
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#bbbbcd",
    height: 2.163,
    rx: 1.081,
    width: 36.46,
    x: 60.641,
    y: 44.672
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#bbbbcd",
    height: 2.163,
    rx: 1.081,
    width: 36.46,
    x: 60.641,
    y: 52.32
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.bd839859.svg";
export { ForwardRef as ReactComponent };